// import ledgerScJgList from '../components/ledgerScJg/ledgerScJgList.vue'
// import viewLedgerScJg from '../components/ledgerScJg/viewLedgerScJg.vue'

export default [
    {
        path: 'ledgerScJg/ledgerScJgList',
        component: resolve => require(['@/components/ledgerScJg/ledgerScJgList'],resolve),
        name: "LedgerScJgList",
        meta:{
            id: '966',
            node: 'ledgerScJg',
            url: 'ledgerScJgList',
        }
    },
    {
        path: 'ledgerScJg/viewLedgerScJg',
        component: resolve => require(['@/components/ledgerScJg/viewLedgerScJg'],resolve),
        name: "ViewLedgerScJg",
        meta:{
            id: '967',
            node: 'ledgerScJg',
            url: 'viewLedgerScJg',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/ledgerScJg.js